import { useEffect, useRef } from "react";

import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { addLogo, deleteLogo, getLogo } from "services/CompanySettings.services";
import { toast } from "sonner";

import { queryClient } from "utils/queryClient";

export function useLogo({ templateLogoPath }: { templateLogoPath: string | null }) {
  const { t } = useTranslation();

  const addLogoMutation = useMutation<any, Error, any>({
    mutationFn: (data) => addLogo(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companySettings"] });
      toast.success("", { description: t("profile.findings.logoAdded") });
    },
  });

  const deleteLogoMutation = useMutation<any, Error>({
    mutationFn: deleteLogo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companySettings"] });
      queryClient.removeQueries({ queryKey: ["logo"] });
      toast.success("", { description: t("profile.findings.logoDeleted") });
    },
  });

  const getLogoQuery = useQuery<any>({
    queryKey: ["logo"],
    queryFn: getLogo,
    enabled: false,
  });

  const { data, isFetching } = getLogoQuery;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) addLogoMutation.mutate({ file });
  };

  useEffect(() => {
    if (templateLogoPath) {
      getLogoQuery.refetch();
    }
  }, [templateLogoPath]);

  return { addLogoMutation, deleteLogoMutation, data, isFetching, inputRef, handleChange };
}
